import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import React from 'react';
import styled from 'styled-components';
import { TipoRelatorio } from '../../../../interface';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.75rem;
  background-color: ${(props) => props.theme.colors.background};
  border-left: 4px solid ${(props) => props.theme.colors.emphasis};
  border-radius: ${(props) => props.theme.border.default};
  padding: 0.75rem 1rem;
  margin: 0;
`;

const Icon = styled.div`
  color: ${(props) => props.theme.colors.emphasis};
  display: flex;
  align-items: center;
  padding-top: 2px;
`;

const Text = styled.p`
  font-size: ${(props) => props.theme.fontSize.medium};
  color: ${(props) => props.theme.colors.gray};
  margin: 0;
  line-height: 1.4;
`;

const Strong = styled.strong`
  color: ${(props) => props.theme.colors.gray};
`;

interface Props {
  tipoRelatorio: TipoRelatorio;
}

function HintBox({ tipoRelatorio }: Props) {
  // Cada relatorio descreve seu proprio escopo, ja que o universo de
  // dados muda: Recebimento foca em tarifas TARIFA_RECEBIMENTO_*,
  // enquanto Tarifas Gerais cobre todas as categorias de tarifa do
  // parceiro (TED, PIX, Boleto, Mensalidade, TIB, SLB, Cartao, Cripto,
  // Domicilio, TEV).
  const escopo =
    tipoRelatorio === 'tarifas' ? (
      <>
        <Strong>Tarifas Gerais</Strong> consolida em um único arquivo todas as
        tarifas movimentadas pelo parceiro no período: TED, PIX, Boleto,
        Mensalidade, TIB, SLB, Cartão, Cripto, Domicílio e TEV. A coluna{' '}
        <Strong>TIPO</Strong> no CSV identifica a categoria de cada linha.
      </>
    ) : (
      <>
        <Strong>Tarifas de Recebimento</Strong> traz apenas as tarifas cobradas
        no recebimento de PIX, TED, TEV, Boleto e Domicílio
        (TARIFA_RECEBIMENTO_*).
      </>
    );

  return (
    <Container>
      <Icon>
        <InfoOutlinedIcon />
      </Icon>
      <Text>
        {escopo} Sua solicitação será processada em segundo plano e pode levar
        alguns minutos. Você pode fechar esta tela — quando o relatório estiver
        pronto, ele aparecerá com o botão de download na tabela abaixo.
      </Text>
    </Container>
  );
}

export default HintBox;
